import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom'; // REMOVED: no hash-to-tickets
import ProductCard from './ProductCard';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { getAllProducts } from '../data/products'; // only need all; tickets removed
import './Section.css';
import './ShopSection.css';

function ShopSection() {
  // const location = useLocation(); // REMOVED
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        // Load products from Firebase (no events)
        const productsSnapshot = await getDocs(collection(db, 'products'));
        const firebaseProducts = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Use Firebase products if any; otherwise fall back to static (filter out tickets if present)
        const list =
          firebaseProducts.length > 0
            ? firebaseProducts
            : getAllProducts();

        // Hard filter to ensure no lingering tickets from any source
        const withoutTickets = list.filter(
          p => p.category !== 'tickets' && !p.isEvent
        );

        setProducts(withoutTickets);
      } catch (error) {
        console.error('Error loading data from Firebase:', error);
        // Fallback to static data on error (filter out tickets)
        setProducts(
          getAllProducts().filter(p => p.category !== 'tickets' && !p.isEvent)
        );
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  // REMOVED: hash navigation that forced tickets view
  // useEffect(() => { ... }, [location.hash, products]);

  const getFilteredProducts = () => {
    if (selectedCategory === 'all') return products;
    return products.filter(product => product.category === selectedCategory);
  };

  const categories = [
    { id: 'all', label: 'ALL ITEMS' },
    // { id: 'tickets', label: 'EVENT TICKETS' }, // REMOVED
    { id: 'merchandise', label: 'MERCHANDISE' },
    { id: 'crafts', label: 'HANDMADE CRAFTS' },
    { id: 'recordings', label: 'RECORDINGS' }
  ];

  return (
    <section className="shop-section" id="shop">
      <h1> </h1>


      {/* Category filters hidden but kept for future use */}
      <div className="category-filters" style={{ display: 'none' }}>
        {categories.map(category => (
          <button
            key={category.id}
            className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category.id)}
          >
            {category.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="products-grid">
          {/* optional: skeletons/spinners */}
          <p>Loading…</p>
        </div>
      ) : (
        <>
          <div className="products-grid">
            {getFilteredProducts().map(product => (
              <div key={product.id} id={product.id} className="product-panel">
                <ProductCard product={product} />
              </div>
            ))}
          </div>

          {getFilteredProducts().length === 0 && (
            <div className="no-products">
              <p>NO ITEMS FOUND IN THIS CATEGORY</p>
            </div>
          )}
        </>
      )}
    </section>
  );
}

export default ShopSection;
